module.exports = {"340272001":"高安街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340272.json
// module id = 1056
// module chunks = 0